import { css } from 'lit';

import { nsReducedMotionStyles } from './ns-motion-styles.js';

export const nsLayoutStyles = css`
  .layout.horizontal,
  .layout.vertical {
    display: flex;
  }
  .layout.inline {
    display: inline-flex;
  }
  .layout.horizontal {
    flex-direction: row;
  }
  .layout.vertical {
    flex-direction: column;
  }
  .layout.wrap {
    flex-wrap: wrap;
  }
  .layout.no-wrap {
    flex-wrap: nowrap;
  }
  .layout.center,
  .layout.center-center {
    align-items: center;
  }
  .layout.center-justified,
  .layout.center-center {
    justify-content: center;
  }
  .flex {
    flex: 1 1 0.000000001px;
  }
  .flex-auto {
    flex: 1 1 auto;
  }
  .flex-none {
    flex: none;
  }

  .layout.start {
    align-items: flex-start;
  }
  .layout.center,
  .layout.center-center {
    align-items: center;
  }
  .layout.end {
    align-items: flex-end;
  }
  .layout.baseline {
    align-items: baseline;
  }

  .layout.start-justified {
    justify-content: flex-start;
  }
  .layout.center-justified,
  .layout.center-center {
    justify-content: center;
  }
  .layout.end-justified {
    justify-content: flex-end;
  }
  .layout.around-justified {
    justify-content: space-around;
  }
  .layout.justified {
    justify-content: space-between;
  }

  .self-start {
    align-self: flex-start;
  }
  .self-center {
    align-self: center;
  }
  .self-end {
    align-self: flex-end;
  }
  .self-stretch {
    align-self: stretch;
  }
  .self-baseline {
    align-self: baseline;
  }

  .layout.start-aligned {
    align-content: flex-start;
  }
  .layout.end-aligned {
    align-content: flex-end;
  }
  .layout.center-aligned {
    align-content: center;
  }
  .layout.between-aligned {
    align-content: space-between;
  }
  .layout.around-aligned {
    align-content: space-around;
  }

  ${nsReducedMotionStyles}
`;
